import { jsx as _jsx } from "react/jsx-runtime";
import { CommandList, useCommandState } from "@air/cmdk";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const ComboboxList = /*#__PURE__*/ memo((param)=>{
    let { children, className, ...restOfProps } = param;
    const isEmpty = useCommandState((state)=>state.filtered.count === 0);
    return /*#__PURE__*/ _jsx(CommandList, {
        className: tailwindMerge("flex grow flex-col", isEmpty ? "p-0" : "p-2", className),
        ...restOfProps,
        children: children
    });
});
ComboboxList.displayName = "ComboboxList";
